import { render, staticRenderFns } from "./projektmanagement-5-1.vue?vue&type=template&id=2182a0c0&"
import script from "./projektmanagement-5-1.vue?vue&type=script&lang=js&"
export * from "./projektmanagement-5-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports